import React from 'react';
import { TT_RED, TT_YELLOW, TT_GREEN, TT_BLUE, TT_PURPLE } from '../const';

const SVG = ({ shape, width = '100%', color = 'blue', style = {}, viewBox = '0 0 100 100' }) => {
  const tt_color = 'tt-color-';

  return (
    <svg
      style={{ ...style, display: 'block' }}
      width={width}
      height={width}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink">
      <defs>
        <linearGradient id={`${tt_color}red`} x1="-200%" y1="-200%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="white" />
          <stop offset="100%" stopColor={TT_RED} />
        </linearGradient>
        <linearGradient id={`${tt_color}yellow`} x1="-200%" y1="-200%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="white" />
          <stop offset="100%" stopColor={TT_YELLOW} />
        </linearGradient>
        <linearGradient id={`${tt_color}green`} x1="-200%" y1="-200%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="white" />
          <stop offset="100%" stopColor={TT_GREEN} />
        </linearGradient>
        <linearGradient id={`${tt_color}blue`} x1="-200%" y1="-200%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="white" />
          <stop offset="100%" stopColor={TT_BLUE} />
        </linearGradient>
        <linearGradient id={`${tt_color}purple`} x1="-200%" y1="-200%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="white" />
          <stop offset="100%" stopColor={TT_PURPLE} />
        </linearGradient>
        {/* CIRCLE */}
        <mask id="tt-clip-circle">
          <g stroke="white" strokeWidth="20">
            <circle cx="50" cy="50" r="40" />
            <circle id="ring" cx="35" cy="35" r="15" />
            <use xlinkHref="#ring" href="#ring" transform="translate(30,0)" />
            <use xlinkHref="#ring" href="#ring" transform="translate(0,30)" />
            <use xlinkHref="#ring" href="#ring" transform="translate(30,30)" />
          </g>
        </mask>
        {/* SQUARE */}
        <mask id="tt-clip-square">
          {/* <rect x="0" y="0" width="100" height="100" fill="white" /> */}
          <g stroke="white" fill="none">
            <circle cx="50" cy="50" r="10" fill="white" />
            <circle cx="50" cy="50" r="20" strokeWidth="10" />
            <circle cx="50" cy="50" r="50" strokeWidth="40" />
          </g>
        </mask>
        {/* RHOMBUS */}
        <mask id="tt-clip-rhombus">
          <g stroke="white" strokeWidth="10" transform="rotate (45,50,50)">
            <rect x="20" y="20" width="60" height="60" />
            <rect x="32" y="32" width="36" height="36" />
            <rect x="44" y="44" width="12" height="12" fill="white" />
          </g>
        </mask>
        {/* STAR */}
        <mask id="tt-clip-star">
          <g fill="white">
            <path id="tt-clip-star-sector" d="M0,50 L 50,19 50,35 C 30,35 30,65 50,65 L 50,81" />
            <circle cx="50" cy="50" r="10" />
            <use xlinkHref="#tt-clip-star-sector" href="#tt-clip-star-sector" transform="rotate(45, 50,50)" />
            <use xlinkHref="#tt-clip-star-sector" href="#tt-clip-star-sector" transform="rotate(90, 50,50)" />
            <use xlinkHref="#tt-clip-star-sector" href="#tt-clip-star-sector" transform="rotate(135, 50,50)" />
            <use xlinkHref="#tt-clip-star-sector" href="#tt-clip-star-sector" transform="rotate(180, 50,50)" />
            <use xlinkHref="#tt-clip-star-sector" href="#tt-clip-star-sector" transform="rotate(225, 50,50)" />
            <use xlinkHref="#tt-clip-star-sector" href="#tt-clip-star-sector" transform="rotate(270, 50,50)" />
            <use xlinkHref="#tt-clip-star-sector" href="#tt-clip-star-sector" transform="rotate(315, 50,50)" />
          </g>
        </mask>
        {/* SEGMENTS */}
        <mask id="tt-clip-segements-clip">
          <path d="M 100,0 L 100,100 0,100 35,65 C 60,80 80,50 65,35" fill="white" />
        </mask>
        <mask id="tt-clip-segments">
          <g fill="white">
            <circle cx="0" cy="0" r="100" mask="url(#tt-clip-segements-clip)" />
            <circle cx="0" cy="0" r="100" mask="url(#tt-clip-segements-clip)" transform="rotate(90, 50,50)" />
            <circle cx="0" cy="0" r="100" mask="url(#tt-clip-segements-clip)" transform="rotate(180, 50,50)" />
            <circle cx="0" cy="0" r="100" mask="url(#tt-clip-segements-clip)" transform="rotate(-90, 50,50)" />
          </g>
        </mask>
        {/* HEARTS */}
        <mask id="tt-clip-hearts">
          <path
            id="heart"
            d="M 10,30 A 20,20 0,0,1 50,30 A 20,20 0,0,1 90,30 Q 90,60 50,90 Q 10,60 10,30"
            transform="scale(0.6,0.6) translate(33,-10)"
            fill="white"
          />
          <use xlinkHref="#heart" href="#heart" transform="rotate(90, 50,50)" />
          <use xlinkHref="#heart" href="#heart" transform="rotate(180, 50,50)" />
          <use xlinkHref="#heart" href="#heart" transform="rotate(-90, 50,50)" />
        </mask>
        {/* COG */}
        <mask id="tt-clip-cog">
          <circle cx="50" cy="50" r="32" stroke="white" strokeWidth="15" />
          <path id="tooth" d="M 11,17 L 17,11 30,20 20,30" fill="white" />
          <use xlinkHref="#tooth" href="#tooth" transform="rotate(30, 50,50)" />
          <use xlinkHref="#tooth" href="#tooth" transform="rotate(60, 50,50)" />
          <use xlinkHref="#tooth" href="#tooth" transform="rotate(90, 50,50)" />
          <use xlinkHref="#tooth" href="#tooth" transform="rotate(120, 50,50)" />
          <use xlinkHref="#tooth" href="#tooth" transform="rotate(150, 50,50)" />
          <use xlinkHref="#tooth" href="#tooth" transform="rotate(180, 50,50)" />
          <use xlinkHref="#tooth" href="#tooth" transform="rotate(210, 50,50)" />
          <use xlinkHref="#tooth" href="#tooth" transform="rotate(240, 50,50)" />
          <use xlinkHref="#tooth" href="#tooth" transform="rotate(270, 50,50)" />
          <use xlinkHref="#tooth" href="#tooth" transform="rotate(300, 50,50)" />
          <use xlinkHref="#tooth" href="#tooth" transform="rotate(330, 50,50)" />
        </mask>
        {/* SWASTIKA */}
        <mask id="tt-clip-swastika">
          <g id="tt-clip-swastika-petal" transform="rotate(-10,50,50)" fill="white">
            <circle cx="50" cy="12.5" r="12.5" />
            <path d="M 45,50 A 1 1,0,1,0, 50,25 V 25,0 A 1,1,0,1,1 45,50" stroke="none" />
          </g>
          <use xlinkHref="#tt-clip-swastika-petal" href="#tt-clip-swastika-petal" transform="rotate(90, 50, 50)" />
          <use xlinkHref="#tt-clip-swastika-petal" href="#tt-clip-swastika-petal" transform="rotate(180, 50, 50)" />
          <use xlinkHref="#tt-clip-swastika-petal" href="#tt-clip-swastika-petal" transform="rotate(-90, 50, 50)" />
        </mask>
        {/* CELTIC */}
        <mask id="tt-clip-celtic">
          <g stroke="white">
            <path
              d="M 25,38 V 62 Q 25,75 38,75 H 62 Q 75,75 75,62 V 38 Q 75,25 62,25 H 38 Q 25,25 25,38 
                    M 42,18 V 82 A 8,8 0,0,0 58,82 V 18 A 8,8 0,0,0 42,18
                    M 18,42 H 82 A 8,8 0,0,1 82,58 H 18 A 8,8 0,0,1 18,42"
              strokeWidth="8"
              transform="rotate(45,50,50) scale(1.44) translate(-15.25,-15.25)"
            />
            <path d="M 0,17 0,0 17,0 M 83,0.75 100,0 100,17 M 100,83 100,100, 83,100 M 0,83 0,100 17,100" fill="white" />
          </g>
        </mask>
      </defs>
      <rect x="0" y="0" width="100" height="100" fill={`url(#${tt_color}${color})`} mask={`url(#tt-clip-${shape})`} />
    </svg>
  );
};

export default SVG;
